import { render, staticRenderFns } from "./FooterPayment.vue?vue&type=template&id=34af0443&"
import script from "./FooterPayment.vue?vue&type=script&lang=js&"
export * from "./FooterPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports